export default {
    stopCards: [],
    stopCardsLoading: false,
    errors: [],
    statuses: [],
    waysOfClosing: [],
    filters: setInitialStopCardsFilters(),
    setInitialStopCardsFilters: setInitialStopCardsFilters
}

function setInitialStopCardsFilters() {
    return {
        search: null,
        createdAt__lte: null,
        createdAt__gte: null,
        productTypeId: null,
        errorId: null,
        productionDepartmentId: null,
        productionProcessId: null,
        createdById: null,
        statusId: null
    }
}